export const SORT_DIRECTION = ["asc", "desc"];
export const INITIAL_LIMIT = "10";
export const INITIAL_PAGE = 0;
export const DAYS_UNTIL_NEXT_ACTION = "days-until-next-action";
export const SEARCH_PARAMS = {
  token: "token",
};

export const PER_PAGE_OPTIONS = [
  { value: 10, label: INITIAL_LIMIT },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const LINKEDIN_REGEX =
  /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile|company)/gm;

export const COMBINED_REGEX =
  /^(N\/A|((http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile|company)))/gm;

export const EMPTY_ARRAY = Object.freeze([]);

export const EMPTY_OBJECT = Object.freeze({});

export const SUPPORT_EMAIL = "mica@marvelous.works";

export const TEST_EMAIL = "mr.externaluser.test@gmail.com";

export const QUALIFIER_OPTIONS = [
  { label: "Spotlight Brand", value: "Spotlight Brand" },
  { label: "Client Requested Brand", value: "Client Requested Brand" },
  { label: "Spending in Target Category", value: "Spending in Target Category" },
  { label: "Spending in Core Category", value: "Spending in Core Category" },
  { label: "Spending in Relevant Channel", value: "Spending in Relevant Channel" },
  { label: "Spending within Competitive Set", value: "Spending within Competitive Set" },
  { label: "Brand Recently Engaged", value: "Brand Recently Engaged" },
];
